import produce from 'immer';
import * as types from './types';

const INITIAL_STATE = {
  comunicado: {},
  modalIsVisible: false
};

export function comunicado(state = INITIAL_STATE, action) {
  return produce(state, draft => {
    switch (action.type) {
      case types.GET_COMUNICADO_CODIGO_TELA_REQUEST: {
        break;
      }
      case types.GET_COMUNICADO_CODIGO_TELA_SUCCESS: {
        draft.modalIsVisible = true;

        draft.comunicado.tituloMensagem = action.payload.tituloMensagem;
        draft.comunicado.corpoMensagem = action.payload.corpoMensagem;
        draft.comunicado.severidade = action.payload.severidade;
        draft.comunicado.codigoTela = action.payload.codigoTela;
        draft.comunicado.dataCadastro = action.payload.dataCadastro;
        draft.comunicado.dataInicioVigencia = action.payload.dataInicioVigencia;
        draft.comunicado.dataExpiracao = action.payload.dataExpiracao;
        draft.comunicado.lgMensagemAtiva = action.payload.lgMensagemAtiva;
        break;
      }
      case types.COMUNICADO_TELA_CLOSE: {
        draft.modalIsVisible = false;
        break;
      }
      default:
        return state;
    }
  });
}
